export enum Permission {
  ResponseConfigurationsView = 'fulfillment_partner_integrations.response_configurations_view',
  ResponseConfigurationsModify = 'fulfillment_partner_integrations.response_configurations_modify',
}
